<template>
  <div class="view">
    <v-card min-width="300">
      <div class="header navy darken-1 secondary--text pa-10 d-flex flex-column align-center">
        <img class="logo" :src="firebase_host + '/static/img/logo_ombra.png'">
      </div>
      <div v-if="!user_uid" class="px-8 py-5 d-flex flex-column align-center">
        <h2 class="mb-5">Accesso Developer</h2>
        <form v-if="Config.LOGIN_DEVELOPER" id="form" @submit.stop.prevent="login_developer">
          <v-text-field label="Username" v-model="username" name="username" required></v-text-field>
          <v-text-field label="Password" v-model="password" name="password" required type="password"></v-text-field>
          <v-btn depressed color="secondary" class="pa-4 white--text" type="submit">Login</v-btn>
        </form>
        <div v-else>
          <p>Accesso developer non disponibile</p>
        </div>
      </div>

    </v-card>
  </div>
</template>

<script>

import mixins from '../../js/mixins'
import toast from "../../js/toast";
import Config from '../../../config-app/config';
import authentication from '../../js/auth'
// import { getAuth } from 'firebase/auth';

// const auth = getAuth();

export default {
  name: 'login-developer',
  mixins: [mixins, toast],
  data() {
    return {
      firebase_host: Config.FIREBASE_HOST,
      displayName: authentication.getDisplayName(),
      username: '',
      password: '',
    }
  },

  methods: {
    login_developer() {
      this.$Progress.start();
      this.$jsonp(Config.API_ENDPOINT + '/firebase_login.php', { mail: this.username, pass: this.password, token: Config.API_TOKEN, callback: 'cb' })
        .then(async (json) => {
          this.$Progress.finish();
          if (json.status === 1) {
            // console.log('submit -> signInUserWithToken')
            const token = json.data.firebase_token;
            // console.log('token', token)
            if (token) {
              const hasLoggedIn = await authentication.signInUserWithToken(token)
              if (hasLoggedIn) {
                // console.log('             -> vai in home')
                this.$router.push({
                  path: '/',
                })
              } else {
                // console.log('             -> login con token non riuscito!')
              }
            } else {
              // console.log('             -> no token')
            }
          } else {
            this.errorToast("", json.msg);
          }
        }).catch(err => {
          this.$Progress.fail();
        });
    },
    logout() {
      authentication.signOutUser();
    }
  },

  mounted() {
    console.log('LoginDeveloper mounted.')
    if (this.user_uid) {
      this.successToast("Utente già loggato", this.displayName);
    }
  },

  created() {

  },

  destroyed() {
    console.log('LoginDeveloper destroyed.');
  }
}
</script>

<style lang="scss" scoped>
.view {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 100%;

  .header {
    position: relative;
    overflow: hidden;

    &:after {
      content: "";
      position: absolute;
      bottom: -15px;
      left: 0;
      width: 115%;
      height: 35px;
      background-color: white;
      transform: skewY(-6deg);
    }
  }

  .logo {
    width: 75px;
  }
}
</style>

